function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#00c381;}.c{fill:#f55f44;opacity:0.5;}.d,.e,.f,.g{fill:none;stroke:#003a3b;}.d{stroke-width:0.573px;}.e{stroke-width:0.39px;}.f{stroke-width:0.444px;}.g{stroke-width:0.322px;}.h{fill:#003a3b;}.i{fill:#e16b67;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-344.379 -270.715)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 193.178,
  height: 144.303,
  transform: "translate(371.245 460.188) rotate(-78.76)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M395.645,469.321s-17.211,3.573-11.572-20.209c-1.22-8.888,11.572-14.429,11.572-14.429l-25.559-16.106-25.707,67.837H373.04l9.147,4.786,13.458-10.256Z",
  transform: "translate(0 -7.176)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 4.927,
  cy: 4.927,
  r: 4.927,
  transform: "translate(384.271 353.032)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "c",
  cx: 2.328,
  cy: 2.328,
  r: 2.328,
  transform: "translate(361.85 281.79)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 6.579,
  cy: 6.579,
  r: 6.579,
  transform: "translate(358.478 279.875)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "d",
  cx: 6.579,
  cy: 6.579,
  r: 6.579,
  transform: "translate(361.293 277.059)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "b",
  cx: 3.869,
  cy: 3.869,
  rx: 3.869,
  ry: 3.869,
  transform: "translate(351.899 399.671)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "e",
  cx: 3.869,
  cy: 3.869,
  rx: 3.869,
  ry: 3.869,
  transform: "translate(353.554 398.016)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 5.1,
  cy: 5.1,
  r: 5.1,
  transform: "translate(566.457 398.016)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "f",
  cx: 5.1,
  cy: 5.1,
  r: 5.1,
  transform: "translate(568.639 395.834)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 10.854,
  height: 10.854,
  transform: "translate(532.451 283.58)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "g",
  width: 10.854,
  height: 10.854,
  transform: "translate(534.409 281.79)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(537.207 363.274)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M447.739,212.669a4.035,4.035,0,1,1,3.964-3.312A4.074,4.074,0,0,1,447.739,212.669Z",
  transform: "translate(-443.711 -204.612)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(451.195 320.252)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M258.9,154.855A28.457,28.457,0,1,1,287.359,126.4,28.487,28.487,0,0,1,258.9,154.855Zm0-48.848A20.391,20.391,0,1,0,279.292,126.4,20.412,20.412,0,0,0,258.9,106.007Z",
  transform: "translate(-230.451 -97.941)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(358.274 280.75)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M263.429,130.367a4.032,4.032,0,0,0-5.137,2.479,57.154,57.154,0,0,1-13.666,21.728,58.161,58.161,0,0,1-6.873,5.882v-18.1a12.189,12.189,0,0,0-12.175-12.176H182.3a12.189,12.189,0,0,0-12.175,12.176v18.172a57.6,57.6,0,0,1-6.873-87.341A57.25,57.25,0,0,1,203.97,56.3H204a57.546,57.546,0,0,1,54.375,38.734A4.033,4.033,0,1,0,266,92.406a65.613,65.613,0,0,0-62-44.174h-.032a65.677,65.677,0,0,0-31.759,123.16l0,0a65.716,65.716,0,0,0,31.667,8.13h.064a65.793,65.793,0,0,0,31.726-8.191l0,0A65.955,65.955,0,0,0,265.908,135.5a4.032,4.032,0,0,0-2.478-5.136Zm-85.24,35.057v-23.07a4.113,4.113,0,0,1,4.108-4.109h43.281a4.113,4.113,0,0,1,4.108,4.109v23.015a58.055,58.055,0,0,1-51.5.055Z",
  transform: "translate(-82.564 -28.779)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M121.43,0A85.055,85.055,0,0,0,52.29,134.631l-7.736,7.737-1.925-1.925a4.034,4.034,0,0,0-5.7,0L25.2,152.173l0,0-19.1,19.1A20.631,20.631,0,1,0,35.27,200.457l19.1-19.105h0L66.1,169.622a4.034,4.034,0,0,0,0-5.7l-1.925-1.925,7.739-7.739A85.076,85.076,0,1,0,121.43,0ZM29.566,194.753A12.565,12.565,0,0,1,11.8,176.981l16.251-16.253,8.875,8.876,8.894,8.895ZM51.521,172.8l-8.875-8.876-8.894-8.895L39.777,149,57.546,166.77Zm6.951-16.507-4.106-4.106-4.109-4.11,7.077-7.078a85.848,85.848,0,0,0,8.216,8.215Zm62.957,5.831a77.027,77.027,0,1,1,77.016-77.027A77.109,77.109,0,0,1,121.43,162.119Z",
  transform: "translate(-0.062)"
})), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M55.912,28.568,35.343.038,54.572-26.6H40.781L28.328-8.71,15.64-26.6H1.139L20.526.511.114,28.568H14.773L27.855,9.417,41.175,28.568Z",
  transform: "translate(500.015 455.1)"
}));

var SvgNoPartner = function SvgNoPartner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234.682,
    height: 217.601,
    viewBox: "0 0 234.682 217.601",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoPartner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-partner.250bb9e9.svg";
export { ForwardRef as ReactComponent };